import React, {useEffect} from 'react';
import Layout from "@/locales/en/layout/Layout";
import {useTranslation} from "react-i18next";
import CustomTitle from "@/components/custom_title";

function Bakalavr5() {

    const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    document.title=t("header.header__sub__menu.menu-6.item-5")

    return (
        <Layout>
            <CustomTitle name={t("header.header__sub__menu.menu-6.item-5")}/>

            <div className="container">
                <p dangerouslySetInnerHTML={{__html: t("bakalavriat.undergraduate5")}}/>
            </div>
        </Layout>
    );
}

export default Bakalavr5;